module.exports = __webpack_public_path__ + "img/team-5.8faaf907.jpg";